<template>
  <v-hover v-slot="{ hover }">
    <div :class="hover ? 'green lighten-5' : ''" class="py-1">
      <v-row align="center">
        <v-col cols="1">
          <div class="font-weight-medium">{{ data_evento }}</div>
        </v-col>
        <v-col cols="4">
          <v-row no-gutters v-for="fito in evento.fitofarmaci" :key="fito.id">
            <v-col cols="8">
              <span class="mr-2"
                ><b>{{
                  fitofarmaco(fito.id_fitofarmaco).dettagli.prodotto
                }}</b></span
              >
              <span class="text-caption grey--text">{{
                fitofarmaco(fito.id_fitofarmaco).dettagli.sostanze_attive
              }}</span>
            </v-col>
            <v-col cols="4">
              <span
                ><b>{{ fito.qta_impiegata }}</b> Kg/Lt.
              </span>
              <v-chip
                v-if="diluizione(fito.qta_impiegata) !== null"
                x-small
                outlined
                color="blue"
                class="ml-1"
              >
                {{ diluizione(fito.qta_impiegata).toFixed(2) }}%
              </v-chip>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1">
          <v-chip v-if="evento.volume_acqua" x-small outlined color="blue">
            <v-icon x-small left>mdi-water-outline</v-icon>
            {{ evento.volume_acqua }} L
          </v-chip>
          <span v-else class="text-caption grey--text">—</span>
        </v-col>
        <v-col cols="2">
          <v-chip
            v-for="id_avversita in evento.id_avversit"
            :key="id_avversita"
            x-small
            outlined
            color="orange darken-2"
            class="mr-1 mb-1"
          >
            <v-icon x-small left>mdi-bug-outline</v-icon>
            {{ avversita(id_avversita).nome }}
          </v-chip>
        </v-col>
        <v-col cols="1">
          <v-chip
            v-for="item in zone_trattate_visibili"
            :key="item.tipo + '-' + item.id"
            x-small
            outlined
            :color="item.tipo === 'zona' ? 'green darken-1' : 'blue darken-1'"
            class="mb-1"
          >
            <v-icon v-if="item.tipo === 'serra'" x-small left
              >mdi-map-marker-radius-outline</v-icon
            >
            {{ item.nome }}
          </v-chip>
          <v-tooltip v-if="zone_trattate_altre.length" top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                x-small
                outlined
                color="grey darken-1"
                class="mb-1"
                v-bind="attrs"
                v-on="on"
              >
                +{{ zone_trattate_altre.length }} altre
              </v-chip>
            </template>
            <div
              v-for="item in zone_trattate_altre"
              :key="item.tipo + '-' + item.id"
            >
              {{ item.tipo === "zona" ? "Zona" : "Serra" }}: {{ item.nome }}
            </div>
          </v-tooltip>
        </v-col>
        <v-col cols="1">
          {{ fase_fenol }}
        </v-col>
        <v-col cols="2">
          <v-dialog width="480" v-model="dialog_colture_trattate">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon color="blue" v-bind="attrs" v-on="on"
                ><v-icon>mdi-open-in-new</v-icon></v-btn
              >
            </template>
            <v-card>
              <v-card-title class="grey--text text-subtitle-1"
                >Colture trattate</v-card-title
              >
              <v-card-text style="max-height: 60vh; overflow-y: auto">
                <v-list dense class="py-0">
                  <template v-for="(gruppo, index) in gruppi_colture_trattate">
                    <ColturaEventoGruppoElement
                      :key="gruppo.id_prodotto"
                      :gruppo="gruppo"
                    />
                    <v-divider
                      v-if="index < gruppi_colture_trattate.length - 1"
                      :key="gruppo.id_prodotto + '-div'"
                      class="my-1"
                    />
                  </template>
                </v-list>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  text
                  color="grey"
                  @click="dialog_colture_trattate = false"
                  >Chiudi</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-tooltip v-if="evento.id_zone.length || evento.id_serre.length" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="blue-grey"
                v-bind="attrs"
                v-on="on"
                @click="$emit('apri-mappa', evento)"
              >
                <v-icon>mdi-map-search-outline</v-icon>
              </v-btn>
            </template>
            <span>Mostra sulla mappa</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="grey"
                v-bind="attrs"
                v-on="on"
                @click="$emit('modifica-evento', evento)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Modifica evento</span>
          </v-tooltip>
          <v-dialog v-model="dialog_elimina" width="400">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon color="red" v-bind="attrs" v-on="on"
                ><v-icon>mdi-delete</v-icon></v-btn
              >
            </template>
            <v-card>
              <v-card-title class="red--text">
                <v-icon color="red" class="mr-2"
                  >mdi-alert-circle-outline</v-icon
                >
                Elimina Evento
              </v-card-title>
              <v-card-text>
                Sei sicuro di voler eliminare l'evento del
                <b>{{ data_evento }}</b
                >? L'operazione non è reversibile e ripristinerà i
                fitofarmaci scaricati nel magazzino.
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn text color="grey" @click="dialog_elimina = false"
                  >Annulla</v-btn
                >
                <v-btn
                  outlined
                  color="red"
                  :loading="loading_elimina"
                  @click="elimina_evento()"
                  ><v-icon class="mr-2">mdi-delete</v-icon>Elimina</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-row v-if="evento.note" no-gutters>
        <v-col cols="12" class="text-caption grey--text font-italic">
          <v-icon x-small class="mr-1">mdi-note-text-outline</v-icon>
          {{ evento.note }}
        </v-col>
      </v-row>
    </div>
  </v-hover>
</template>

<script>
import evento_list_mixin from "../mixin/evento_list_mixin";
import ColturaEventoGruppoElement from "./coltura_evento_gruppo_element.vue";
export default {
  components: {
    ColturaEventoGruppoElement,
  },
  mixins: [evento_list_mixin],
};
</script>
